module.exports = __webpack_public_path__ + "static/img/so4_5.eddc6fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so4_5.jpg
// module id = Vk46
// module chunks = 11